import React from 'react';

const icons = {
  home: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.1 22.5V15.3C8.1 14.6635 8.35285 14.0531 8.80294 13.603C9.25304 13.1529 9.86348 12.9 10.5 12.9H12.9C13.5365 12.9 14.147 13.1529 14.5971 13.603C15.0471 14.0531 15.3 14.6635 15.3 15.3V22.5M3.3 11.7H0.9L11.7 0.9L22.5 11.7H20.1V20.1C20.1 20.7365 19.8471 21.347 19.3971 21.7971C18.947 22.2471 18.3365 22.5 17.7 22.5H5.7C5.06348 22.5 4.45304 22.2471 4.00294 21.7971C3.55285 21.347 3.3 20.7365 3.3 20.1V11.7Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  extraHome: (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.75 9.75H18.75L9.75 0.75L0.75 9.75H2.75V16.75C2.75 17.2804 2.96071 17.7891 3.33579 18.1642C3.71086 18.5393 4.21957 18.75 4.75 18.75H9.75M6.75 18.75V12.75C6.75 12.2196 6.96071 11.7109 7.33579 11.3358C7.71086 10.9607 8.21957 10.75 8.75 10.75H10.75C11.2804 10.75 11.7891 10.9607 12.1642 11.3358C12.5393 11.7109 12.75 12.2196 12.75 12.75M16.75 20.25C16.9553 19.4013 17.3906 18.6255 18.0081 18.0081C18.6255 17.3906 19.4013 16.9553 20.25 16.75C19.4013 16.5447 18.6255 16.1094 18.0081 15.4919C17.3906 14.8745 16.9553 14.0987 16.75 13.25C16.5447 14.0987 16.1094 14.8745 15.4919 15.4919C14.8745 16.1094 14.0987 16.5447 13.25 16.75C14.0987 16.9553 14.8745 17.3906 15.4919 18.0081C16.1094 18.6255 16.5447 19.4013 16.75 20.25Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  star: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9998 17.748L5.82784 20.993L7.00684 14.12L2.00684 9.253L8.90684 8.253L11.9928 2L15.0788 8.253L21.9788 9.253L16.9788 14.12L18.1578 20.993L11.9998 17.748Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  plusIcon: (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.45833 0.625V12.2917M0.625 6.45833H12.2917"
        stroke="#E4ECEC"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  discountIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.5 7.5C6.5 7.76522 6.60536 8.01957 6.79289 8.20711C6.98043 8.39464 7.23478 8.5 7.5 8.5C7.76522 8.5 8.01957 8.39464 8.20711 8.20711C8.39464 8.01957 8.5 7.76522 8.5 7.5C8.5 7.23478 8.39464 6.98043 8.20711 6.79289C8.01957 6.60536 7.76522 6.5 7.5 6.5C7.23478 6.5 6.98043 6.60536 6.79289 6.79289C6.60536 6.98043 6.5 7.23478 6.5 7.5Z"
        stroke="#043B3B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 6V11.172C3.00011 11.7024 3.2109 12.211 3.586 12.586L11.296 20.296C11.748 20.7479 12.3609 21.0017 13 21.0017C13.6391 21.0017 14.252 20.7479 14.704 20.296L20.296 14.704C20.7479 14.252 21.0017 13.6391 21.0017 13C21.0017 12.3609 20.7479 11.748 20.296 11.296L12.586 3.586C12.211 3.2109 11.7024 3.00011 11.172 3H6C5.20435 3 4.44129 3.31607 3.87868 3.87868C3.31607 4.44129 3 5.20435 3 6Z"
        stroke="#043B3B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 13.847L11 15L11.532 13.143L10 12H11.902L12.5 10.2L13.098 12H15L13.468 13.143L14 15L12.5 13.847Z"
        stroke="#043B3B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

export default icons;
